import React, { useEffect } from 'react';
import { isClassElement } from '@solid-ui-components/utils/isClassElement';

const useOutsideClick = (ref, callback) => {
  const handleClick = (event) => {
    const target = event.target;
    if (ref.current && !ref.current.contains(target)) {
      callback(event);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

const isInIgnoredElement = (element, ignoredClass) => {
  if (isClassElement(element, ignoredClass)) return true;
  if (!(element = element.parentElement)) {
    return false;
  } else {
    if (isClassElement(element, ignoredClass)) {
      return true;
    }
    isInIgnoredElement(element, ignoredClass);
  }
};

export default (ref, handler, ignoredClass) =>
  useOutsideClick(ref, (event) => {
    if (event?.target && isInIgnoredElement(event.target, ignoredClass)) {
      return;
    }
    handler(event);
  });
